import { render, staticRenderFns } from "./ConfirmSearchModal.vue?vue&type=template&id=6b500c4a"
import script from "./ConfirmSearchModal.vue?vue&type=script&lang=js"
export * from "./ConfirmSearchModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports